<div mat-dialog-title>
  Mass AI Avatar Generation
</div>
<mat-dialog-content>
  <div class="wrapper">
    <mat-radio-group class="radio-group" [(ngModel)]="selectedOption">
      <mat-radio-button class="radio-button" [value]="AiGenerationOption.OnlyWithoutAi">
        Only avatars without AI
      </mat-radio-button>
      @if (canRegenerateAllAvatars) {
        <mat-radio-button class="radio-button" [value]="AiGenerationOption.All">
          Regenerate all avatars
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button 
    type="button" 
    mdbBtn 
    class="waves-light btn-danger btn" 
    aria-label="Cancel" 
    (click)="cancel()" 
    mdbWavesEffect>
    Cancel
  </button>
  <button 
    type="button" 
    mdbBtn 
    class="waves-light btn-success btn" 
    aria-label="Confirm" 
    (click)="confirm()" 
    mdbWavesEffect>
    Confirm
  </button>
</mat-dialog-actions>
